import type { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import type { ComponentOrientation } from '@/types';
import Title from '@/components/Title';
import { classes } from './utils';

export type StepTitleProps = {
  className?: string;
  orientation?: ComponentOrientation;
  title: string;
  subtitle?: string;
  icon?: ReactElement;
};

export default function StepTitle({
  className,
  orientation = 'vertical',
  title,
  subtitle,
  icon,
}: StepTitleProps) {
  return (
    <div
      className={twMerge(
        orientation === 'horizontal' && classes.horizontal,
        className
      )}>
      {icon}
      <Title className={classes.title} size="xs">
        {title}
      </Title>
      {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
    </div>
  );
}
